import { GET_SAVED_ITEMS } from "./constants";
// import logger from "../../../../helpers/logger";

const sdkRequest = /* istanbul ignore next */ async dispatch => {
  // try {
  //   const { savedItemProducts } = await window.asos.sdk.savedItems.getSavedItems();
  //
  //   dispatch({ type: GET_SAVED_ITEMS, payload: savedItemProducts });
  // } catch (err) {
  //   logger.error(`Error while fetching saved items: ${err}`);
  //
  //   dispatch({ type: GET_SAVED_ITEMS, error: true, payload: err });
  // }
  dispatch({ type: GET_SAVED_ITEMS, payload: [] });
};

export const getSavedItemsFromSDK = /* istanbul ignore next */ () => /* istanbul ignore next */ dispatch => {
  return new Promise(function(resolve) {
    if (window.asos.sdk.savedItems) return resolve(sdkRequest(dispatch));

    window.asos.eventBus.addListener("sdk-ready", () =>
      resolve(sdkRequest(dispatch))
    );
  });
};



// WEBPACK FOOTER //
// ./template/state/modules/savedItems/actions.js